import { render, staticRenderFns } from "./station-detail-setting-edit.vue?vue&type=template&id=21f60412&scoped=true&"
import script from "./station-detail-setting-edit.vue?vue&type=script&lang=js&"
export * from "./station-detail-setting-edit.vue?vue&type=script&lang=js&"
import style0 from "./station-detail-setting-edit.vue?vue&type=style&index=0&id=21f60412&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f60412",
  null
  
)

export default component.exports